import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";
import { getArticlesById } from "services/article_service";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";


function App() {
  const { t } = useTranslation();
  const [article, setArticle] = useState({
    attributes: { title: "", content: "" },
  });

  useEffect(() => {
    async function getArtsById() {
      try {
        const urlSplit = window.location.href.split("/");

        const article = await getArticlesById(urlSplit[urlSplit.length - 1]);
        console.log("🚀 ~ getArtsById ~ article:", article)
        setArticle(article);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getArtsById();
  }, []);

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
          <TopAdd></TopAdd>
          <div style={{"display": "flex"}}>

          <section className="section">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li>
                  <Link to={"/artigos"}>{t("articles")}</Link>
                </li>
               
              </ul>
            </nav>

            <div className="hero is-footsolution">
              <div className="columns">
                <div className="column">
                  <h1 className="title is-3">{article.attributes.title}</h1>

                  <span>{article.attributes.content}</span>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column is-9">
                
              </div>
            </div>
          </section>

          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}
export default App;
